
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class UnlockUserDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return UnlockUserForm.formKey; }

        private form: UnlockUserForm;

        private UnlockUsers: string;
        private Usernames: string;
        private numbers: string;

        get UnlockUser()
        {
            return this.UnlockUsers;
        }

        set UnlockUser(value: string) {
            if (this.UnlockUsers != value) {
                this.UnlockUsers = value;
            }
            console.log('UnlockUsers: ' + this.UnlockUsers);
            this.form.UnlockUser.value = this.UnlockUsers;
        }

        get Username()
        {
            return this.Usernames;
        }

        set Username(value: string) {
            if (this.Usernames != value) {
                this.Usernames = value;
            }
            console.log('Username: ' +  this.Usernames);
        }

        constructor() {
            super();
            this.form = new UnlockUserForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Unlock User";
        }

        protected getDialogButtons() {
            return [
                {
                    text: "OK",
                    click: () => {
                        if (!this.validateBeforeSave()) return;

                        //EX.
                        this.numbers = this.form.UnlockUser.value;
                        const dlg = new UserDialog();
                        dlg.UnlockUsers = this.numbers;
                        
                        UnlockUserService.PosUnlockUser({
                            Username: this.Usernames,
                            UserActive: this.numbers,
                        });

                        this.dialogClose();
                    },
                },
                {
                    text: "Close",
                    click: () => this.dialogClose(),
                },
            ];
        }

    }
    
}